export const MethodTypes = {
    APPMAIL: 'I received a paper application in the mail',
    APPPERSON: 'I completed a paper application in a face to face meeting with beneficiary',
    APPPORTAL: 'I am entering the application directly in the Portal'
}

export type MethodType = 'APPMAIL' | 'APPPERSON' | 'APPPORTAL'

export const SoaTypes = {
    SOAINCLUDED: 'A scope of Appointment is included with this enrollment form',
    SOANOTINCLUDED: 'Scope of Appointment was NOT completed because the agent did not have an individual or one-on-one ' +
        'marketing appointment(whether in person, telephonically or otherwise) with the applicant.'
}

export type SoaType = 'SOAINCLUDED' | 'SOANOTINCLUDED'

export interface MethodSoa {
    methodType: string,
    isSoaComplete: boolean
}